import type { AccountTrialInfo } from '@hotjar/account';

type NonNullableProperties<TObject> = {
  [TKey in keyof TObject]: NonNullable<TObject[TKey]>;
};

/**
 * TODO: Use SetNonNullable from type-fest instead of this after updating the package
 */
type EnsureNonNullableProperty<T, K extends keyof T> = T & NonNullableProperties<Pick<T, K>>;

export const isOnActiveTrial = (
  trialInfo: AccountTrialInfo | null,
): trialInfo is EnsureNonNullableProperty<AccountTrialInfo, 'active' | 'daysRemaining'> =>
  trialInfo?.active != null &&
  trialInfo.active &&
  trialInfo?.daysRemaining != null &&
  trialInfo.daysRemaining > 0;

export const isOnEligibleTrial = (trialInfo: AccountTrialInfo | null): boolean =>
  !isOnActiveTrial(trialInfo) && trialInfo?.activeOrEligible != null && trialInfo.activeOrEligible;

export const isOnActiveOrEligibleTrial = (trialInfo: AccountTrialInfo | null): boolean =>
  isOnEligibleTrial(trialInfo) || isOnActiveTrial(trialInfo);

export const getTrialRemainingDays = (trialInfo: AccountTrialInfo | null): number | null =>
  isOnActiveTrial(trialInfo) ? Math.floor(trialInfo.daysRemaining) : null;
